import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

export interface IProps {
    items: BreadcrumbItem[]
}

export type BreadcrumbItem = {
    title: string
    onClick?(): void
}

const Breadcrumb = ({ items = [] }: IProps): JSX.Element => {
    if (items.length === 0) return <></>

    return (
        <StyleBreadcrumb>
            {items.map(({ title, onClick }, index) => {
                return (
                    <BreadcrumbItem key={index}>
                        <a onClick={onClick}>{i18n(title)}</a>
                    </BreadcrumbItem>
                )
            })}
        </StyleBreadcrumb>
    )
}

export default Breadcrumb

const StyleBreadcrumb = styled.ul`
    display: flex;
    padding: 0;
    margin: 0;
`

const BreadcrumbItem = styled.li`
    a {
        text-decoration: underline;
    }

    &:last-child {
        a {
            color: ${({ theme }) => theme['gray-600']};
            text-decoration: none;
        }

        &::after {
            content: '';
            margin: 0;
        }
    }

    &::after {
        content: '\f105';
        margin: 0 8px;
        font-family: 'Font Awesome 5 Pro';
        color: ${({ theme }) => theme['blue-500']};
    }
`
